import { h, Fragment } from 'preact';
import {useEffect} from 'preact/hooks';
import config from '../../config.json';

export default function TypeOfPaper(props) {
  const {
    disciplinesIds,
    state,
    setState
  } = props;

  const {
    disciplines
  } = config;
  return (
    <Fragment>
      <span>Discipline</span>
      <div className="select">
        <select onClick={(e) => {
          setState({
            ...state,
            disciplineId: +e.target.value
          })
        }}>
          {
            disciplines.map(item => {
              if (disciplinesIds.includes(item.id)) {
                return (
                  <option
                    value={item.id}
                    key={item.id}
                    selected={item.id === state.disciplineId ? 'selected' : ''}
                  >{item.name}</option>
                )
              }
            })
          }
        </select>
      </div>
    </Fragment>
  )
}
